module.exports = __webpack_public_path__ + "Roboto-Light.054fa50baa6598a7bf0c.svg";


//////////////////
// WEBPACK FOOTER
// /app/~/roboto-fontface/fonts/Roboto/Roboto-Light.svg
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-Light.svg
// module chunks = 13